import { Colors } from "@brg/ui";
import styled from "styled-components";

export const ContactButtonContainer = styled.div`
    display: flex;
    flex-direction: row;
    gap: 8px;
`;

export const ContactButtonItem = styled.div`
    display: flex;
    flex-direction: row;
    gap: 8px;
    color: ${Colors.galBlack47};
    text-decoration: underline;
    cursor: pointer;
    font-size: 17px;
    font-weight: 600;
    line-height: 22px;
    transition: color 0.2s ease;
    &:hover {
        color: ${Colors.galBlack100};
        transition: color 0.2s ease;
    }
    &:active {
        color: ${Colors.galBlack100};
    }
    &:focus {
        color: ${Colors.galBlack100};
    }
`;
import { Colors } from "@brg/ui";
import styled from "styled-components";

export const ContactButtonContainer = styled.div`
    display: flex;
    flex-direction: row;
    gap: 8px;
`;

export const ContactButtonItem = styled.div`
    display: flex;
    flex-direction: row;
    gap: 8px;
    color: ${Colors.galBlack47};
    text-decoration: underline;
    cursor: pointer;
    font-size: 17px;
    font-weight: 600;
    line-height: 22px;
    transition: color 0.2s ease;
    &:hover {
        color: ${Colors.galBlack100};
        transition: color 0.2s ease;
    }
    &:active {
        color: ${Colors.galBlack100};
    }
    &:focus {
        color: ${Colors.galBlack100};
    }
`;
